var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseWhiteAndBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#83888e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "stop",
    id: "stop-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,2H7A1,1,0,0,0,6,3V21a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V3A1,1,0,0,0,11,2ZM10,20H8V4h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,2H15a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V3A1,1,0,0,0,19,2ZM18,20H16V4h2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseWhiteAndBlack);
export default __webpack_public_path__ + "static/media/pauseWhiteAndBlack.1aaa5526c49b5f0b9dacbd8c79004052.svg";
export { ForwardRef as ReactComponent };